import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Move from "@store/Components/Icons/Move";
import Target from "@store/Components/Icons/Target";
import { RsswProductModel } from "@store/Types/ApiModels";
import React, { FC } from "react";

import { css } from "styled-components";

export interface RsswProductContextModel {
    product: RsswProductModel;
}

const enum fits {
    DirectFit = "Direct Fit",
    MultiFit = "Multi Fit",
}

interface OwnProps {
    product: RsswProductContextModel;
    extendedStyles?: ProductFitTypeStyles;
}

type Props = OwnProps;

export interface ProductFitTypeStyles {
    directFitIcon?: IconPresentationProps;
    multiFitIcon?: IconPresentationProps;
    wrapperDirectFit?: InjectableCss;
    wrapperMultiFit?: InjectableCss;
    fitLabel?: TypographyPresentationProps;
}

export const wrapperFit = css`
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    margin: 0;
`;

export const productFitTypeStyles: ProductFitTypeStyles = {
    wrapperDirectFit: {
        css: wrapperFit,
    },
    wrapperMultiFit: {
        css: wrapperFit,
    },
    directFitIcon: {
        src: Target,
        size: 26,
        css: css`
            margin-right: 7px;
        `,
    },
    multiFitIcon: {
        src: Move,
        size: 22,
        css: css`
            margin-right: 7px;
        `,
    },
    fitLabel: {
        css: css`
            line-height: 1;
        `,
    },
};

const ProductFitType: FC<Props> = ({ product, extendedStyles }) => {
    if (!product || !product.product.fit) {
        return null;
    }

    const renderFit = () => {
        if (product.product.fit === "DirectFit") {
            return (
                <StyledWrapper {...styles.wrapperDirectFit}>
                    <Icon {...styles.directFitIcon} />
                    <Typography {...styles.fitLabel}>{fits.DirectFit}</Typography>
                </StyledWrapper>
            );
        }

        return (
            <StyledWrapper {...styles.wrapperMultiFit}>
                <Icon {...styles.multiFitIcon} />
                <Typography {...styles.fitLabel}>{fits.MultiFit}</Typography>
            </StyledWrapper>
        );
    };

    const [styles] = React.useState(() => mergeToNew(productFitTypeStyles, extendedStyles));

    return renderFit();
};

export default ProductFitType;
